import jsQR from 'jsqr';

export default class QrCodeScannerController {
	/* @ngInject */
	constructor($element, $scope, $translate) {
		this.$element = $element;
		this.$scope = $scope;
		this.$translate = $translate;

		this.canvas = undefined;
		this.canvasElement = undefined;
		this.message = undefined;
		this.ngModelCtrl = undefined;
		this.ready = false;
		this.video = undefined;
	}

	drawLine(begin, end, color) {
		this.canvas.beginPath();
		this.canvas.moveTo(begin.x, begin.y);
		this.canvas.lineTo(end.x, end.y);
		this.canvas.lineWidth = 4;
		this.canvas.strokeStyle = color;
		this.canvas.stroke();
	}

	tick() {
		this.message = this.$translate.instant('qrcode.init');
		if (!this.ready) {
			this.ready = this.video.readyState === this.video.HAVE_ENOUGH_DATA;
			this.$scope.$apply();
		}

		if (this.ready) {
			this.canvasElement.height = this.video.videoHeight;
			this.canvasElement.width = this.video.videoWidth;
			this.canvas.drawImage(this.video, 0, 0, this.canvasElement.width, this.canvasElement.height);
			const imageData = this.canvas.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
			const code = jsQR(imageData.data, imageData.width, imageData.height, {
				inversionAttempts: 'dontInvert',
			});
			if (code) {
				this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, '#FF3B58');
				this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, '#FF3B58');
				this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, '#FF3B58');
				this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, '#FF3B58');
				this.message = '';
				if (code.data) {
					this.ngModel = code.data.trim();
					this.ngModelCtrl.$setViewValue(code.data.trim());
					this.ngModelCtrl.$validate();
					this.$scope.$apply();
				}
			}
			else {
				this.message = this.$translate.instant('qrcode.init');
				this.data = null;
			}
		}
		window.requestAnimationFrame(() => this.tick());
	}

	$onInit() {
		this.message = this.$translate.instant('qrcode.error');

		this.video = document.createElement('video');
		this.canvasElement = this.$element.find('canvas').get(0);
		this.canvas = this.canvasElement.getContext('2d');

		// Use facingMode: environment to attemt to get the front camera on phones
		navigator.mediaDevices.getUserMedia({
			video: { facingMode: 'environment' },
		}).then(stream => {
			this.video.srcObject = stream;
			this.video.setAttribute('playsinline', true); // required to tell iOS safari we don't want fullscreen
			this.video.play();
			return window.requestAnimationFrame(() => this.tick());
		}).catch(error => {
			console.log('error', error);
		});
	}

	$onDestroy() {
		if (this.video.srcObject) {
			this.video.srcObject.getTracks()[0].stop();
		}
	}
}
